import React, { useEffect, useRef, useState } from 'react';
import { Table } from 'antd';
import 'antd/dist/antd.min.css';
import moment from 'moment';
import TableConfig from './TableConfig';
import { Title } from '../../../../../../../common/ui/Common';
import { getColumnSearchProps } from './getColumnSearchProps';
import { getProcessTime, getWaitingTime } from './utils';
import { ReportBox } from '../../../../../components/report/ReportTableColumns';

function TicketList({ data }) {
  const [searchText, setSearchText] = useState();
  const [searchedColumn, setSearchedColumn] = useState();
  const [actualData, setActualData] = useState(data);
  const input = useRef(null);

  useEffect(() => {
    if (!Array.isArray(data)) {
      setActualData([]);
      return;
    }
    const arrayData = JSON.parse(JSON.stringify(data));
    setActualData(arrayData.map((ticket) => ({
      ...ticket,
      createdOn: moment(ticket.createdOn).format('DD.MM.YYYY HH:mm:ss'),
      modifiedOn: moment(ticket.modifiedOn).format('DD.MM.YYYY HH:mm:ss'),
      waitingTime: getWaitingTime(ticket),
      processTime: getProcessTime(ticket),
      first_start_time: ticket.first_start_time ? ticket.first_start_time : '01.01.2000 01:01:01',
    })));
  }, [data]);

  const config = TableConfig(getColumnSearchProps({
    input,
    searchedColumn,
    searchText,
    handleSearch(selectedKeys, confirm, dataIndex) {
      confirm();
      setSearchText(selectedKeys[0]);
      setSearchedColumn(dataIndex);
    },
    handleReset(clearFilters) {
      clearFilters();
      setSearchText('');
    },
  }));

  return (data ? (
    <ReportBox>
      <Title>Список талонов</Title>
      <div>
        <Table
          rowKey="id"
          dataSource={actualData}
          columns={config.columns}
          bordered
          size="large"
          scroll={{ x: 1350 }}
        />
      </div>
    </ReportBox>
  ) : (<div>Пусто</div>));
}

export default React.memo(TicketList);
